var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-loader"},[_vm._t("default",function(){return [_c('KSkeletonBox',{attrs:{"width":"100","height":"1"}}),_c('KSkeletonBox',{attrs:{"width":"100","height":"1"}}),_c('KSkeletonBox',{attrs:{"width":"75","height":"1"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }